import request from '@/utils/request';

export function getUserTerm() {
  return request({
    url: '/About/userTerm',
  });
}

export function getPaymentAgreement() {
  return request({
    url: '/About/paymentAgreement',
  });
}

export function getJoinUsInfo() {
  return request({
    url: '/About/joinUs',
  });
}
